import {ComponentInternalInstance, EffectScope, getCurrentInstance, inject} from 'vue';

const mocks: Map<string, any> = new Map();
const instances: Map<string, any> = new Map();

export function useService<T>(service: {new (): T}, singleton: boolean = true): T {
    const name: string = service.name;
    if (singleton) {
        let instance: ComponentInternalInstance = getCurrentInstance();
        if (instance && instance.appContext.provides[name]) {
            return inject(name);
        } else if (mocks.has(name)) {
            return mocks.get(name);
        }
        if (!instances.has(name)) {
            const effectScope = new EffectScope(true);
            effectScope.run(() => {
                instances.set(name, Reflect.construct(service, []));
            });
            instances.set(name + ':scope', effectScope);
        }
        return instances.get(name);
    } else {
        return Reflect.construct(service, []);
    }
}

export function resetMocks(): void {
    mocks.clear();
}

export function provideMocks(listMocks: any): any {
    mocks.clear();
    Object.keys(listMocks).forEach((name: string) => {
        mocks.set(name, listMocks[name]);
    });
    return listMocks;
}

export function destroyService(service: Function): void {
    if (instances.has(service.name) && instances.get(service.name).destroy) {
        instances.get(service.name).destroy();
        instances.get(service.name + ':scope').stop();
    }
    instances.delete(service.name);
    instances.delete(service.name + ':scope');
}
